import {
  BackendFetch,
  DevTools,
  FormatSimple,
  LanguageDetector,
  LanguageStorage,
  Tolgee,
  TolgeeProvider,
} from "@tolgee/react";
import { PropsWithChildren } from "react";
import { TOLGEE_SETTINGS } from "src/env.ts";

const tolgee = Tolgee()
  .use(LanguageStorage())
  .use(LanguageDetector())
  .use(
    BackendFetch({
      prefix: TOLGEE_SETTINGS.TRANSLATIONS_PREFIX,
    }),
  )
  .use(DevTools())
  .use(FormatSimple())
  .init({
    defaultLanguage: TOLGEE_SETTINGS.DEFAULT_LANGUAGE,
    fallbackLanguage: TOLGEE_SETTINGS.DEFAULT_LANGUAGE,
    availableLanguages: TOLGEE_SETTINGS.AVAILABLE_LANGUAGES,
    projectId: TOLGEE_SETTINGS.PROJECT_ID,
    apiUrl: TOLGEE_SETTINGS.API_URL,
    apiKey: TOLGEE_SETTINGS.API_KEY,
  });

export const I18nProvider = ({ children }: PropsWithChildren) => {
  return <TolgeeProvider tolgee={tolgee}>{children}</TolgeeProvider>;
};
